import { Box, FormHelperText, InputLabel, Typography } from '@mui/material'

type FormControlProps = {
  children: React.ReactNode

  label?: string
  id?: string
  helperText?: React.ReactNode
  error?: boolean
  /** shows asterisk after label */
  required?: boolean
  /** select binds label differently */
  select?: boolean
  /** adds the delete button to the right of input */
  onRemove?: () => void
}

export type FormControlWrapper = Omit<FormControlProps, 'children'>

export const FormControl = ({
  label,
  select,
  required,
  onRemove,
  children,
  helperText,
  error,
  id,
}: FormControlProps) => {
  const labelConnector = id ?? label

  return (
    <Box width="100%" display="inline-flex" flexDirection="column" minWidth={0}>
      {label && (
        <InputLabel
          disableAnimation
          shrink
          id={select ? labelConnector : undefined}
          htmlFor={select ? undefined : labelConnector}
          required={required}
          sx={{
            position: 'static',
            display: 'flex',
            transform: 'none',
            mb: 0.5,
            pr: onRemove ? 6 : 0,

            '& .MuiTypography-root': {
              fontSize: '0.875rem',
              fontWeight: 600,
            },

            '&.Mui-focused': {
              color: 'text.primary',
            },
          }}
        >
          <Typography component="span">{label}</Typography>
        </InputLabel>
      )}
      <Box display="flex" width="100%">
        {children}
      </Box>
      {helperText && (
        <FormHelperText
          error={error}
          sx={{
            mt: 1,
            color: 'text.primary',
            '&.Mui-error': {
              color: 'error.main',
            },
          }}
        >
          <Typography variant="caption2" fontWeight={500}>
            {helperText}
          </Typography>
        </FormHelperText>
      )}
    </Box>
  )
}
